getContextFlavor